<template>
  <data-policy-component />
</template>
<script>
import DataPolicyComponent from '@/components/legal/DataPolicyComponent.vue'
export default {
  components: { DataPolicyComponent },
}
</script>